module.exports = "/_next/static/images/fallback_M-32911311a8fe47bf59dd545dec21a764.png";